import {
	ListItemIcon,
	Menu,
	MenuItem,
	Typography,
	useTheme,
} from "@mui/material";
import type { FC, ReactElement, SetStateAction } from "react";

const WIDTH = 200;

type Item = {
	icon: ReactElement;
	label: string;
	onClick?: () => void;
};

type Props = {
	anchorEl: HTMLElement | null;
	setAnchorEl: (value: SetStateAction<HTMLElement | null>) => void;
	items: Item[];
};

export const ToolBarMenu: FC<Props> = ({ anchorEl, setAnchorEl, items }) => {
	const theme = useTheme();

	return (
		<Menu
			anchorEl={anchorEl}
			open={anchorEl !== null}
			onClose={() => setAnchorEl(null)}
			sx={{
				"& .MuiPaper-root": {
					width: WIDTH,
					maxWidth: WIDTH,
					borderRadius: "12px",
				},
			}}
		>
			{items.map((item) => (
				<MenuItem
					key={item.label}
					onClick={() => {
						item.onClick?.();
						setAnchorEl(null);
					}}
				>
					<ListItemIcon sx={{ svg: { color: theme.palette.primary.main } }}>
						{item.icon}
					</ListItemIcon>
					<Typography
						fontSize={14}
						fontWeight={500}
						color={theme.palette.grey[700]}
					>
						{item.label}
					</Typography>
				</MenuItem>
			))}
		</Menu>
	);
};
